// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
  privacyPolicy: '/politica-de-privacidade',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
  },
  master: {
    root: path(ROOTS_DASHBOARD, '/master'),
    company: path(ROOTS_DASHBOARD, '/company'),
    companyNew: path(ROOTS_DASHBOARD, '/company/new'),
    companyEdit: path(ROOTS_DASHBOARD, '/company/:uraKey/edit'),
  },
  reporting: {
    atendimentos: path(ROOTS_DASHBOARD, '/reporting/atendimentos'),
    bi: path(ROOTS_DASHBOARD, '/reporting/bi'),
  },
  campaigns: {
    root: path(ROOTS_DASHBOARD, '/campaigns'),
    new: path(ROOTS_DASHBOARD, '/campaigns/new'),
    edit: path(ROOTS_DASHBOARD, '/campaigns/:id/edit'),
  },
  pabx: {
    geral: path(ROOTS_DASHBOARD, '/pabx/geral'),
    graphic: path(ROOTS_DASHBOARD, '/pabx/graphic'),
    generalStatistics: path(ROOTS_DASHBOARD, '/pabx/general-statistics'),
    callRecordings: path(ROOTS_DASHBOARD, '/pabx/call-recording'),
    PabxAgenteLogin: path(ROOTS_DASHBOARD, '/pabx/pabx-agente-login'),
  },
  calls: {
    root: path(ROOTS_DASHBOARD, '/calls'),
    id: path(ROOTS_DASHBOARD, '/calls/:id'),
  },
  callback: {
    root: path(ROOTS_DASHBOARD, '/callback'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey'),
  },
  internalChat: {
    root: path(ROOTS_DASHBOARD, '/internal-chat'),
  },
  internalChatAdmin: {
    root: path(ROOTS_DASHBOARD, '/internal-chat-admin'),
  },
  inperson: {
    root: path(ROOTS_DASHBOARD, '/inperson'),
  },
  userContacts: {
    root: path(ROOTS_DASHBOARD, '/agenda'),
  },
  kanban: {
    root: path(ROOTS_DASHBOARD, '/kanban'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account'),
  },
  chats: {
    root: path(ROOTS_DASHBOARD, '/chats'),
    ura: path(ROOTS_DASHBOARD, '/chats/ura'),
    uraNew: path(ROOTS_DASHBOARD, '/chats/ura/new'),
    uraEdti: path(ROOTS_DASHBOARD, '/chats/ura/:uraKey/edit'),
    troncos: path(ROOTS_DASHBOARD, '/chats/troncos'),
    new: path(ROOTS_DASHBOARD, '/chats/troncos/new'),
    troncokEdit: path(ROOTS_DASHBOARD, '/chats/troncos/:troncoKey'),
  },
  config: {
    root: path(ROOTS_DASHBOARD, '/config'),
    general: path(ROOTS_DASHBOARD, '/config/general'),
    nps: path(ROOTS_DASHBOARD, '/nps'),
    pending: path(ROOTS_DASHBOARD, '/config/pending'),
    messages: path(ROOTS_DASHBOARD, '/config/messages'),
    transhipment: path(ROOTS_DASHBOARD, '/config/transhipment'),
    queueNotification: path(ROOTS_DASHBOARD, '/config/queue-notification'),
    timeline: path(ROOTS_DASHBOARD, '/config/timeline'),
    group: path(ROOTS_DASHBOARD, '/config/group'),
    groupEdit: path(ROOTS_DASHBOARD, `/config/group/reece-chung/edit`),
    groupNew: path(ROOTS_DASHBOARD, `/config/group/new`),
    users: path(ROOTS_DASHBOARD, '/config/users'),
    contacts: path(ROOTS_DASHBOARD, '/config/contacts'),
  },
  online: {
    root: path(ROOTS_DASHBOARD, '/online/users'),
    view: path(ROOTS_DASHBOARD, '/online/users/:id/view'),
  },
  activity: {
    root: path(ROOTS_DASHBOARD, '/activity'),
  },
  agentAdmin: {
    logs: path(ROOTS_DASHBOARD, '/agent-admin/logs'),
  },
  videocall: {
    root: path(ROOTS_DASHBOARD, '/videocall'),
  },
  forms: {
    root: path(ROOTS_DASHBOARD, '/forms'),
    list: path(ROOTS_DASHBOARD, '/forms/list'),
    new: path(ROOTS_DASHBOARD, '/forms/new'),
    view: (id) => path(ROOTS_DASHBOARD, `/forms/${id}/view`),
    edit: (id) => path(ROOTS_DASHBOARD, `/forms/${id}/edit`),
  },
};

export const PATH_DOCS = 'https://google.com.br';
